import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../base/base.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';
import { Milestone } from '../../../../models/api/view/claim/details/accommodations/milestones';
import { ClaimKey } from '../../../../models/api/core/claim-key';

@Component({
  selector: 'app-milestones',
  imports: [TableComponent, ColumnComponent, PageHeaderComponent],
  template: `
    <app-page-header label="Milestones" />
    <div class="tw-w-full">
      <div class="tw-w-3/4">
        <app-table
          [dataSource]="milestones"
          [pageSize]="5"
          [scrollable]="false"
          [expandable]="false"
          dataKey="milestoneDate"
          recordLabel="milestone"
        >
          <app-column name="milestoneDate" label="Date" format="d" />
          <app-column name="milestone" label="Milestone" />
          <app-column name="createdBy" label="Created By" />
        </app-table>
      </div>
    </div>
  `,
  styles: ``,
})
export class MilestonesComponent extends BaseComponent implements OnInit {
  claim = this.view.currentClaim();
  milestones: Milestone[] = [];

  async ngOnInit(): Promise<void> {
    const claimKey: ClaimKey = {
      recordId: this.claim.recordId,
      recordSource: this.claim.recordSource,
    };
    this.milestones = await this.api.milestones.get(claimKey);
    this.view.hideLoading();
  }
}
